export enum PackingState {
    Unknown,
    Incident,
    Packed,
    Packing,
    Picked,
    OutOfPacking
}